import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import Login from "components/FrontEnd/Login";
import Frontend from  "layouts/Frontend/Frontend.jsx";
import AdminLogin from  "layouts/Dashboard/AdminAuth.jsx";


var indexRoutes = [
	
	{ path: "/Admin-login", name: "AdminLogin", component: AdminLogin, exactPro:false},
	{ path: "/login", name: "FrontendLogin", component: Login , exactPro:false},
	{ path: "/Admin", name: "Home", component: Dashboard, exactPro:false },
	{ path: "/", name: "Frontend", component: Frontend , exactPro:false}
	
	
	
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx